// extracted by mini-css-extract-plugin
export default {"content":"Content_content__D7w+n","title":"Content_title__x-etx","description":"Content_description__0z6iQ"};